import { Finance } from "./finance.model";
import { Purchase } from "./purchase.model";
import { Receipt } from "./receipt.model";

export class Dept {
  id?: string;
  mode?: string; //receipt/purchase/payment

  issueDate?: Date;
  code?: string;
  amount?: number;
  paid?: number;
  debit?: number;
  note?: string;

  timestamp?: number;
  //detail
  receipt?: Receipt;
  purchase?: Purchase;
  payment?: Finance;

  deptDetails?: DeptDetail[];
}

export class DeptDetail {
  receiptId?: string;
  issueDate?: Date;
  code?: string;
  note?: string;

  productId?: string;
  productCode: string;
  productName: string;
  productDescription: string;
  productUnitName: string;

  discountPercent: number;
  discountAmount: number;
  quantity: number;
  price: number;
  amount: number;
  netAmount: number;
  comment: string;

  timestamp?: number;
}
